<template>
  <div class="plan-selector-container">
    <!-- 左滑动按钮 -->
    <div class="nav-arrow left-arrow" @click="scrollLeft" v-show="canScrollLeft">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </div>

    <!-- 计划列表容器 -->
    <div class="plans-wrapper" ref="plansWrapper">
      <div class="plan-item" v-for="(plan, index) in plans" :key="index" :class="{ 'active': activeIndex === index }"
        @click="selectPlan(index)">
        <div class="plan-content">
          <div class="plan-top-right">
            <p class="plan-time" v-if="!plan.tag">
              <img v-if="plan.timing" :src="plan.rightImg" style="width: 127px !important;height: 33px !important;"/>
            <div class="plan-countdown" v-if="plan.timing && plan.countdown">
              <countdown ref="countdown" :timestamp="endTimestamp" enableCache
                @countdown-end="handleCountdownEnd(plan)" />

            </div>
            </p>
            <p class="plan-tab" v-if="plan.tag">
              <!-- <img :src="plan.rightImg" style="width: 107px !important;height: 33px !important;"/> -->
              <span class="plan-tag">{{ plan.tag }}</span>
            </p>
          </div>
          <h3 class="plan-title">{{ plan.typeName }}</h3>
          <div class="plan-price">
            <span class="price"><span class="money">￥</span>{{ plan.price }}</span>
            <span class="oprice"><span class="money">￥</span>{{ plan.originalCost }}</span>
          </div>
          <div class="plan-price t-m-b-10">
            <span class="day-price" v-if="!plan.description">￥{{ plan.dayPrice }}/天</span>
            <span class="desc" v-else>
              <span>{{ plan.description }}</span>
            </span>
          </div>
          <div class="plan-footer">
            <div class="plan-qy-icon">
              <img src="@/assets/image/vip/icon1_1.png" width="82" height="16" />
            </div>
              <steps :steps="plan.steps"></steps>
          </div>
        </div>
      </div>
    </div>

    <!-- 右滑动按钮 -->
    <div class="nav-arrow right-arrow" @click="scrollRight" v-show="canScrollRight">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </div>
  </div>
</template>

<script>
import steps from '@/components/dongeb/steps.vue';//收费选项模式
import Countdown from '@/components/dongeb/countDown.vue'
export default {
  name: 'PlanSelector',
  components: {
    steps, Countdown
  },
  props: {
    plans: {
      type: Array,
      required: true,
    },
    initialActiveIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      activeIndex: this.initialActiveIndex,
      currentScroll: 0,
      maxScroll: 0,
      itemWidth: 266,
      visibleItems: 4,
      // 10小时后的时间戳
      endTimestamp: Date.now() + 10 * 60 * 60 * 1000
    }
  },
  computed: {
    canScrollLeft() {
      return this.currentScroll > 0 && this.plans.length > this.visibleItems
    },
    canScrollRight() {
      return this.currentScroll < this.maxScroll && this.plans.length > this.visibleItems
    }
  },
  mounted() {
    this.calculateDimensions()
    window.addEventListener('resize', this.calculateDimensions)
    this.$nextTick(() => {
      this.scrollToActive()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateDimensions)
  },
  methods: {
    handleCountdownEnd(item) {
      console.log('10小时倒计时结束后重新开始')
      this.endTimestamp = Date.now() + 10 * 60 * 60 * 1000
    },
    calculateDimensions() {
      const containerWidth = this.$el.offsetWidth
      this.visibleItems = Math.min(Math.floor(containerWidth / this.itemWidth), this.plans.length)
      this.maxScroll = Math.max(0, (this.plans.length - this.visibleItems) * this.itemWidth)

      // 响应式调整
      if (window.innerWidth < 768) {
        this.itemWidth = 240
      } else {
        this.itemWidth = 266
      }
    },
    scrollToActive() {
      // 确保活动项可见
      const activePosition = this.activeIndex * this.itemWidth
      const scrollEnd = this.currentScroll + (this.visibleItems * this.itemWidth)

      if (activePosition < this.currentScroll) {
        // 活动项在左侧不可见区域
        this.currentScroll = activePosition
      } else if (activePosition + this.itemWidth > scrollEnd) {
        // 活动项在右侧不可见区域
        this.currentScroll = activePosition - (this.visibleItems - 1) * this.itemWidth
      }

      this.updateScroll()
    },
    selectPlan(index) {
      this.activeIndex = index
      this.$emit('plan-selected', index)

      // 智能滑动逻辑
      const position = index * this.itemWidth
      const visibleStart = this.currentScroll
      const visibleEnd = visibleStart + (this.visibleItems * this.itemWidth)

      if (position < visibleStart) {
        // 点击了左侧不可见的计划
        this.currentScroll = position
      } else if (position + this.itemWidth > visibleEnd) {
        // 点击了右侧不可见的计划
        this.currentScroll = position - (this.visibleItems - 1) * this.itemWidth
      } else if (index === Math.floor(visibleStart / this.itemWidth) && this.canScrollLeft) {
        // 点击了最左边的可见计划，且左边还有内容
        this.currentScroll = Math.max(0, this.currentScroll - this.itemWidth)
      } else if (index === Math.floor(visibleEnd / this.itemWidth) - 1 && this.canScrollRight) {
        // 点击了最右边的可见计划，且右边还有内容
        this.currentScroll = Math.min(this.maxScroll, this.currentScroll + this.itemWidth)
      }

      this.updateScroll()
    },
    scrollLeft() {
      this.currentScroll = Math.max(0, this.currentScroll - this.itemWidth)
      this.updateScroll()
    },
    scrollRight() {
      this.currentScroll = Math.min(this.maxScroll, this.currentScroll + this.itemWidth)
      this.updateScroll()
    },
    updateScroll() {
      this.$refs.plansWrapper.style.transform = `translateX(-${this.currentScroll + 50}px)`
    }
  },
  watch: {
    plans() {
      this.$nextTick(() => {
        this.calculateDimensions()
        this.scrollToActive()
      })
    },
    initialActiveIndex(newVal) {
      this.activeIndex = newVal
      this.$nextTick(this.scrollToActive)
    }
  }
}
</script>

<style lang="scss" scoped>
h3,
p {
  margin: 0;
  padding: 0;
}

.plan-selector-container {
  position: relative;
  width: 100%;
  max-width: 1300px;
  margin: 0 auto;
  padding: 0 49px;
  overflow: hidden;
}

.plans-wrapper {
  display: flex;
  transition: transform 0.3s ease;
  will-change: transform;
  padding: 5px 0;
}

.plan-item {
  flex: 0 0 266px;
  padding: 0 15px;
  box-sizing: border-box;
  transition: all 0.3s ease;
}

.plan-content {
  height: 506px;
  width: 266px;
  background-color: transparent !important;
  // border: 1px solid #E4E7ED;
  border-radius: 20px;
  padding: 25px 15px 10px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  background-image: url('@/assets/image/vip/noCur.png');
  background-repeat: no-repeat;
  background-position: 0px;
  // background-size: 506px 266px;
  background-size: cover;
}

.plan-item.active .plan-content {
  // border-color: var(--tech-primary);
  border: 0 !important;
  box-shadow: 0 8px 24px rgba(64, 158, 255, 0.2);
  transform: translateY(-5px);
  border-radius: 22px;
  background-image: url('@/assets/image/vip/cur.png');
  background-position: 0px;
  background-repeat: no-repeat;
  background-size: cover;
}

.plan-top-right {
  position: absolute;
  top: 0;
  right: 0;

  .plan-time,
  .plan-tab {
    position: relative;
  }
  .plan-tag{
    border-top-right-radius: 22px;
    border-bottom-left-radius: 28px;
    background: linear-gradient(to right, #f72828, #fe8e35);
    height: 33px;
    min-width: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 15px;
    font-size: 14px;
    color: #fff;
  }
  .plan-countdown {
    position: absolute;
    top: 0;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.plan-title {
  height: 19px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 20px;
  color: #613C3C;
  line-height: 16px;
}

.plan-price {
  margin-top: 10px;

  .price {
    color: #613E35;
    font-family: Microsoft YaHei;
    font-size: 38px;
    line-height: 1;

    .money {
      font-size: 28px !important;
    }
  }

  .oprice {
    text-decoration: line-through;
    color: #E5A743;
    font-family: Microsoft YaHei;
    font-size: 16px;
    line-height: 1;
    padding-left: 5px;
  }

  .day-price {
    color: #FF2828;
    font-family: Microsoft YaHei;
    font-size: 16px;
    height: 42px;
    display: block;
  }

  .desc {
    display: block;
    font-size: 16px;
    height: 42px;

    span {
      // width: 100%;
      color: #C77136;
    }
  }
}

.plan-footer {
  position: relative;
  border-top: 1px solid #ddd;
  overflow: auto;
  @include no_scrollbar();

  .plan-qy-icon {
    padding-top: 10px;
    margin-bottom: 10px;
  }
}

.select-btn {
  padding: 10px 24px;
  background: var(--tech-primary);
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.select-btn:hover {
  background: var(--tech-primary);
}

.select-btn.selected {
  background: var(--tech-primary);
}

.nav-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 48px;
  height: 48px;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  z-index: 10;
  color: var(--tech-primary);
  transition: all 0.3s;
}

.nav-arrow:hover {
  color: #66B1FF;
  transform: translateY(-50%) scale(1.1);
}

.left-arrow {
  left: 10px;
}

.right-arrow {
  right: 10px;
}

/* 响应式设计 */
/* @media (max-width: 1200px) {
  .plan-item {
    flex: 0 0 240px;
  }
}

@media (max-width: 992px) {
  .plan-selector-container {
    padding: 0 30px;
  }
  
  .plan-content {
    height: 460px;
    padding: 20px;
  }
}

@media (max-width: 768px) {
  .plan-selector-container {
    padding: 0 20px;
  }
  
  .plan-item {
    flex: 0 0 220px;
  }
  
  .plan-content {
    height: 420px;
  }
  
  .nav-arrow {
    width: 36px;
    height: 36px;
  }
}

@media (max-width: 576px) {
  .plan-selector-container {
    padding: 0 15px;
  }
  
  .plan-item {
    flex: 0 0 200px;
  }
  
  .plan-content {
    height: 380px;
    padding: 15px;
  }
  
  .plan-price {
    font-size: 24px;
    margin-bottom: 15px;
  }
} */
</style>